module.exports = __webpack_public_path__ + "static/sickle-efcef8e092aae9616753b0eb4f67867a.jpg";